/**
 * Data for performance block
 */

module.exports = [
  {
    name: ['P1⁽²⁾ <br><small>45% €<br> 55% UC</small>', 'P2 <br><small>40% €<br> 60% UC</small>', 'P3 <br><small>35% €<br> 65% UC</small>', 'P4 <br><small>30% €<br> 70% UC</small>', 'P5 <br><small>25% €<br> 75% UC</small>', 'P6 <br><small>20% €<br> 80% UC</small>', 'P7 <br><small>15% €<br> 85% UC</small>', 'P8 <br><small>10% €<br> 90% UC</small>', 'P9 <br><small>5% €<br> 95% UC</small>', 'P10 <br><small>0% €<br> 100% UC</small>'],
    perf: [1.46,  3.38, 4.84, 5.63, 8.69, 10.42, 11.10, 11.92, 13.85, 16.32],
    vol:  [1.49,  2.14, 2.91, 3.73, 4.22,  5.32,  5.98,  6.89,  7.45,  9.05],
    PMR:  [-1.51,-1.66,-1.49,-1.67,-1.85, -2.64, -3.05, -3.71, -4.10, -4.88],
    PME:  [-1.79,-2.56,-3.48,-4.47,-5.08, -6.35, -7.15, -8.27, -8.93,-10.88]
  }
];
